<template>
    <div class="app-secondary-container">
        <aside class="app-aside scrollfix">
            <div class="app-aside__content scrollfix">
                <project-option-nav/>
            </div>
        </aside>
        <main class="app-main">
            <router-view/>
        </main>
    </div>
</template>
<script>
    import ProjectOptionNav from '../components/Nav/ProjectOptionNav';

    export default {
        components: { ProjectOptionNav }
    }
</script>
